var _style, _g, _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 240 61",
    style: {
      enableBackground: "new 0 0 240 61"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#717271;}\n\t.st1{fill:none;stroke:#717271;stroke-width:1.5243;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:url(#SVGID_7_);}\n\t.st9{fill:url(#SVGID_8_);}\n\t.st10{fill:#272425;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.4,40.8c-10.6,0-17.3-6.8-17.3-15c0-8.1,6.7-14.9,17.3-14.9c4.3,0,7.9,1,11.2,3.5 c0.5,0.3,0.6,0.8,0.6,1.2c0,1-1.1,2-2.3,1.3c-3.1-2.1-5.8-3-9.4-3c-8.3,0-13.3,5.2-13.3,11.9c0,6.8,4.9,11.9,13.3,11.9 c3.3,0,6.5-0.9,9.6-3c0.3-0.2,0.6-0.3,0.9-0.3c0.8,0,1.5,0.6,1.5,1.4c0,0.5-0.3,1-0.7,1.2C116.6,39.6,112.7,40.8,108.4,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.2,40.8c-10.5,0-17.6-6.3-17.6-15c0-8.6,7.1-14.9,17.6-14.9c10.5,0,17.7,6.3,17.7,14.9 C159.8,34.5,152.7,40.8,142.2,40.8z M142.2,13.9c-7.7,0-13.3,4.8-13.3,11.9c0,7.1,5.6,11.9,13.3,11.9c7.7,0,13.3-4.8,13.3-11.9 C155.5,18.7,149.9,13.9,142.2,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.3,28.6h-12.8v10.2c0,1.3-1.1,2-2.1,2c-1,0-2-0.7-2-2V13.3c0-1.3,1-1.9,2.1-1.9h15.3 c7.2,0,11.5,3.4,11.5,8.6c0,4.2-2.8,7.1-7.5,8.2l7.7,9.4c0.3,0.4,0.6,0.9,0.6,1.4c0,1-0.8,1.8-1.8,1.8c-0.6,0-1.3-0.3-1.9-1.1 L182.3,28.6z M169.5,14.4v11.2h13.3c4.9,0,7.4-2.5,7.4-5.6c0-3.1-2.4-5.6-7.4-5.6H169.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.2,31.9h-23.8v7c0,1.2-1,1.9-2,1.9c-0.9,0-2-0.7-2-1.9v-14c0-8.3,7.5-14,15.9-14c8.4,0,15.9,5.8,15.9,14 v14c0,1.2-1,1.9-2,1.9c-0.9,0-2-0.7-2-1.9V31.9z M229.2,25.9c0-7.6-5.6-12.1-11.9-12.1c-6.3,0-11.9,4.4-11.9,12.1v3h23.8V25.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.1,50.8v3c0,0.4-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.2-0.6-0.6v-7.2c0-0.4,0.3-0.5,0.6-0.5h4.3 c2,0,3.4,0.8,3.4,2.4c0,1.6-1.3,2.4-3.4,2.4H97.1z M97.1,46.9V50h3.7c1.4,0,2.2-0.6,2.2-1.5c0-0.9-0.7-1.6-2.2-1.6H97.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,49.3c0.7-0.8,1.7-1.2,2.7-1.2c2.2,0,2.9,1.2,2.9,2.7v3c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.6-0.2-0.6-0.5 v-2.7c0-1.1-0.4-2.2-2-2.2c-1.2,0-2.3,0.7-2.5,1.7l0,3.2c0,0.3-0.3,0.5-0.6,0.5s-0.5-0.2-0.5-0.5v-8c0-0.3,0.2-0.5,0.5-0.5 s0.6,0.2,0.6,0.5V49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.3,48.3c0.1-0.2,0.3-0.3,0.4-0.3c0.3,0,0.5,0.2,0.5,0.5c0,0.1,0,0.2-0.1,0.2l-2.1,3.6 c-2.2,3.7-3.2,4.4-4.8,4.4c-0.3,0-0.4-0.2-0.4-0.4c0-0.3,0.2-0.4,0.4-0.4c0.8,0,1.5-0.3,2.8-2.1l-3-5c0-0.1-0.1-0.2-0.1-0.2 c0-0.3,0.2-0.5,0.5-0.5c0.2,0,0.4,0.1,0.5,0.3l2.8,4.5l0.5-0.9L122.3,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.3,54.4c-1.4,0-2.4-0.2-3-0.6c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.2,0.2-0.4,0.3-0.4s0.2,0,0.3,0.1 c0.8,0.3,1.4,0.5,2.5,0.5c1.2,0,2.1-0.3,2.1-1c0-1.5-5.1-0.5-5.1-2.8c0-1.2,1.4-1.7,3.1-1.7c1,0,2.2,0.2,2.7,0.5 c0.1,0.1,0.2,0.2,0.2,0.3c0,0.2-0.1,0.4-0.4,0.4c-0.1,0-0.2,0-0.2-0.1c-0.7-0.2-1.3-0.4-2.3-0.4c-1,0-1.9,0.3-1.9,0.9 c0,1.5,5.1,0.3,5.1,2.8C131.6,53.8,130.1,54.4,128.3,54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.2,46.6c0-0.3,0.2-0.7,0.7-0.7c0.5,0,0.7,0.4,0.7,0.7c0,0.3-0.2,0.7-0.7,0.7 C134.5,47.3,134.2,47,134.2,46.6z M134.4,48.6c0-0.4,0.3-0.5,0.5-0.5c0.3,0,0.6,0.2,0.6,0.5v4c0,0.6,0.2,0.8,0.5,0.9 c0.2,0,0.4,0.2,0.4,0.4c0,0.3-0.2,0.4-0.5,0.4c-1.1,0-1.5-0.5-1.5-1.7V48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145,52.7c0.2,0,0.4,0.2,0.4,0.4c0,0.1-0.1,0.2-0.2,0.3c-0.8,0.6-1.8,0.9-2.7,0.9c-2.4,0-4-1.4-4-3.1 s1.5-3.1,4-3.1c0.8,0,2,0.3,2.8,0.9c0.1,0.1,0.1,0.2,0.1,0.3c0,0.2-0.2,0.4-0.4,0.4c-0.1,0-0.2,0-0.3-0.1 c-0.5-0.4-1.3-0.7-2.1-0.7c-1.7,0-2.9,0.9-2.9,2.3c0,1.4,1.2,2.3,2.9,2.3c0.8,0,1.6-0.2,2.1-0.7C144.7,52.8,144.9,52.7,145,52.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.6,54.4c-0.3,0-0.5-0.2-0.5-0.5V53c-0.5,0.8-1.5,1.4-2.9,1.4c-2.1,0-3.6-1.2-3.6-3.1 c0-1.9,1.4-3.1,3.5-3.1c1.4,0,2.4,0.5,2.9,1.3v-0.8c0-0.3,0.2-0.5,0.5-0.5c0.4,0,0.6,0.2,0.6,0.5v5.2 C155.2,54.1,155,54.4,154.6,54.4z M154.1,51.1c-0.1-1.5-1.3-2.2-2.7-2.2c-1.5,0-2.6,0.9-2.6,2.3c0,1.5,1.1,2.3,2.6,2.3 c1.4,0,2.7-0.8,2.7-2.3V51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.3,45.8c0-0.3,0.3-0.5,0.5-0.5s0.6,0.2,0.6,0.5v6.8c0,0.6,0.2,0.9,0.5,0.9c0.2,0,0.3,0.2,0.3,0.4 c0,0.3-0.2,0.4-0.4,0.4c-1.1,0-1.5-0.5-1.5-1.7V45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.5,46.9h-3.4c-0.2,0-0.4-0.2-0.4-0.5c0-0.3,0.2-0.5,0.4-0.5h7.9c0.2,0,0.4,0.2,0.4,0.5 c0,0.3-0.2,0.5-0.4,0.5h-3.4v6.8c0,0.4-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.2-0.6-0.6V46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179,49.3c0.7-0.8,1.7-1.2,2.7-1.2c2.2,0,2.9,1.2,2.9,2.7v3c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.6-0.2-0.6-0.5 v-2.7c0-1.1-0.4-2.2-2-2.2c-1.2,0-2.3,0.7-2.5,1.7l0,3.2c0,0.3-0.3,0.5-0.6,0.5c-0.3,0-0.5-0.2-0.5-0.5v-8c0-0.3,0.2-0.5,0.5-0.5 c0.3,0,0.6,0.2,0.6,0.5V49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.4,51.6c0.2,1.1,1,2,2.8,2c1,0,1.8-0.3,2.4-0.8c0.1-0.1,0.2-0.2,0.3-0.2c0.2,0,0.4,0.2,0.4,0.4 c0,0.1,0,0.2-0.1,0.3c-0.7,0.7-1.8,1-3,1c-2,0-3.9-1-3.9-3.1c0-2,1.7-3.2,3.7-3.2c2.1,0,3.7,1.1,3.7,2.9c0,0.4-0.2,0.6-0.5,0.6 H188.4z M188.3,50.9h5.1c0-1.1-1-2-2.6-2C189.4,48.9,188.5,49.7,188.3,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.2,48.6c0-0.3,0.3-0.5,0.6-0.5c0.3,0,0.5,0.2,0.5,0.5v1.2c0.6-1,1.5-1.7,2.8-1.7c0.2,0,0.4,0.1,0.4,0.4 c0,0.3-0.2,0.5-0.5,0.5c-1.5,0-2.8,1-2.8,2.5v2.3c0,0.3-0.3,0.5-0.6,0.5c-0.3,0-0.6-0.2-0.6-0.5V48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.6,54.4c-0.3,0-0.5-0.2-0.5-0.5V53c-0.5,0.8-1.5,1.4-2.9,1.4c-2.1,0-3.6-1.2-3.6-3.1 c0-1.9,1.4-3.1,3.5-3.1c1.4,0,2.4,0.5,2.9,1.3v-0.8c0-0.3,0.2-0.5,0.5-0.5c0.4,0,0.6,0.2,0.6,0.5v5.2 C211.1,54.1,210.9,54.4,210.6,54.4z M210,51.1c-0.1-1.5-1.3-2.2-2.7-2.2c-1.5,0-2.6,0.9-2.6,2.3c0,1.5,1.1,2.3,2.6,2.3 c1.4,0,2.7-0.8,2.7-2.3V51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.7,48.1c0.3,0,0.5,0.2,0.5,0.5v0.8c0.5-0.8,1.5-1.3,2.9-1.3c2.1,0,3.6,1.2,3.6,3.1 c0,1.9-1.5,3.1-3.6,3.1c-1.4,0-2.4-0.6-2.9-1.4v3.3c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.6-0.2-0.6-0.5v-7.7 C214.1,48.3,214.4,48.1,214.7,48.1z M215.2,51.1v0.2c0.1,1.5,1.3,2.2,2.7,2.2c1.5,0,2.6-0.9,2.6-2.3c0-1.5-1.1-2.3-2.6-2.3 C216.6,48.9,215.3,49.6,215.2,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.1,48.3c0.1-0.2,0.3-0.3,0.4-0.3c0.3,0,0.5,0.2,0.5,0.5c0,0.1,0,0.2-0.1,0.2l-2.1,3.6 c-2.2,3.7-3.2,4.4-4.8,4.4c-0.3,0-0.4-0.2-0.4-0.4c0-0.3,0.2-0.4,0.4-0.4c0.8,0,1.5-0.3,2.8-2.1l-3-5c0-0.1-0.1-0.2-0.1-0.2 c0-0.3,0.2-0.5,0.5-0.5c0.2,0,0.4,0.1,0.5,0.3l2.8,4.5L228,52L230.1,48.3z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 80.5,
    y1: 9.6,
    x2: 80.5,
    y2: 56.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.8699,
    y1: 22.8824,
    x2: 41.5021,
    y2: 8.5431,
    gradientTransform: "matrix(0.9818 -1.416777e-02 1.442819e-02 0.9999 25.9224 13.6581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07140828,
    style: {
      stopColor: "#95D600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1628,
    style: {
      stopColor: "#A4DC25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    style: {
      stopColor: "#C4E871"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    style: {
      stopColor: "#DDF2AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7053,
    style: {
      stopColor: "#F0F9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8248,
    style: {
      stopColor: "#FBFDF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.5,25.4c0.4,1.4,0.6,2.9,0.6,4.4c0,1.9-0.3,3.7-1.1,5.4c-0.3,0.7-0.7,1.3-1,1.9c-0.5,0.8-1.1,1.6-1.7,2.3 c-0.6,0.7-1.2,1.5-1.7,2.2c-0.7,1-1.4,2-1.8,3.1c-0.5,1.1-0.7,2.2-0.8,3.4c0,0.5,0,1-0.1,1.5c0,0.9,0.1,1.7,0.4,2.5 c0.4,1.1,1,2.1,1.6,3.1c0.1,0.2,0.2,0.3,0.3,0.5c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0-0.3,0C53,56,48.3,56,43.5,56.1 c-0.2,0-0.4,0.1-0.6,0c-0.2-0.1-0.1-0.4-0.1-0.6c-0.1-3.4,1-6.4,3.2-9c2-2.4,4.2-4.7,6.6-6.9c1.5-1.4,3.1-2.8,4.6-4.1 c0.7-0.6,1.4-1.3,2-1.9c2.1-2.1,3.5-4.6,4.1-7.5c0-0.2,0.1-0.3,0.1-0.5C63.4,25.5,63.4,25.5,63.5,25.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.1962,
    y1: 23.9402,
    x2: 58.5089,
    y2: -2.9836,
    gradientTransform: "matrix(0.9818 -1.416777e-02 1.442819e-02 0.9999 25.9224 13.6581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6587,
    style: {
      stopColor: "#F1F1F2"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.6,24.8c0.2,0.2,0,0.6,0,0.8c-0.1,0.4-0.2,0.8-0.3,1.1c-0.2,0.8-0.5,1.6-0.8,2.3 c-0.6,1.4-1.5,2.6-2.6,3.7c-1.1,1.2-2.4,2.3-3.6,3.4c-1.3,1.1-2.5,2.3-3.7,3.4c-1.2,1.1-2.3,2.2-3.5,3.4 c-1.1,1.2-2.2,2.4-3.2,3.7c-1.8,2.3-2.8,5.2-2.8,8.2c0,0.2,0,0.4,0,0.5c0,0.2,0,0.4,0,0.5c-0.1,0.3-0.5,0.2-0.7,0.2 c-0.9,0-1.7,0-2.6,0c-1.7,0-3.4,0-5.1,0.1c-0.8,0-1.6,0-2.4,0c-0.2,0-0.5,0.1-0.5-0.1c0-0.1,0.1-0.2,0.1-0.3 c0.1-0.2,0.2-0.5,0.3-0.7c0.6-1.5,1.3-3,2.1-4.4c1.6-2.7,3.5-5.3,5.7-7.4c2.3-2.2,4.9-4,7.5-5.6c2.8-1.7,5.7-3.3,8.4-5.1 c2.5-1.7,4.8-3.8,6.6-6.2c0.2-0.3,0.4-0.6,0.6-0.9C62.4,25.3,62.6,25.1,62.6,24.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.7969,
    y1: 10.4691,
    x2: 40.3792,
    y2: 2.2243,
    gradientTransform: "matrix(0.9818 -1.416777e-02 1.442819e-02 0.9999 25.9224 13.6581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007DA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1F1F2"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M62.5,22.6c0,0.9-0.4,1.6-0.9,2.3c-0.5,0.8-1,1.5-1.6,2.2c-1.2,1.4-2.5,2.6-3.9,3.7c-3,2.3-6.3,4-9.5,6 c-3,1.8-6,3.8-8.5,6.4c-2.5,2.5-4.6,5.4-6.2,8.6c-0.4,0.8-0.8,1.7-1.2,2.6c-0.2,0.5-0.3,0.9-0.5,1.4c-0.2,0.4-0.2,0.6-0.6,0.7 c-1.9,0.1-3.8,0.1-5.7,0.1c-0.5,0-1,0-1.5,0c-0.2,0-0.6,0.1-0.6-0.1c0-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.4,0.3-0.5 c0.2-0.4,0.5-0.8,0.7-1.3c1-1.6,2-3.2,3.1-4.7c2.1-2.9,4.5-5.5,7.3-7.8c2.8-2.3,5.8-4.2,9-5.9c3.3-1.8,6.8-3.2,10.2-4.9 c1.6-0.8,3.2-1.7,4.6-2.8c1.4-1,2.7-2.3,3.8-3.6c0.3-0.3,0.6-0.7,0.9-1.1c0.1-0.1,0.2-0.3,0.3-0.4 C62.3,22.8,62.4,22.7,62.5,22.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.2262,
    y1: 12.3131,
    x2: 43.3612,
    y2: 2.2636,
    gradientTransform: "matrix(0.9818 -1.416777e-02 1.442819e-02 0.9999 25.9224 13.6581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003DA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09809154,
    style: {
      stopColor: "#2F60B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    style: {
      stopColor: "#6D90CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    style: {
      stopColor: "#A1B8DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5112,
    style: {
      stopColor: "#CAD7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6282,
    style: {
      stopColor: "#E7EDF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7292,
    style: {
      stopColor: "#F9FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.3,21.4c0,0.2-0.1,0.3-0.2,0.5c-0.2,0.2-0.3,0.5-0.5,0.7c-0.3,0.4-0.6,0.8-0.9,1.2 c-0.6,0.8-1.3,1.5-2,2.2c-1.4,1.3-3,2.4-4.7,3.4c-1.8,1-3.6,1.8-5.4,2.7c-1.9,0.9-3.8,1.8-5.6,2.7c-3.5,1.8-6.8,3.8-9.9,6.3 c-2.9,2.4-5.5,5.3-7.8,8.5c-1.2,1.7-2.3,3.4-3.3,5.2c-0.3,0.5-0.5,0.9-0.8,1.4c-0.2,0.3-0.5,0.3-0.9,0.3c-0.9,0-1.8,0-2.8-0.1 c-0.6-0.1-1.6-0.1-2.1-0.6c-0.3-0.3-0.3-0.7-0.2-1c0.1-0.5,0.2-0.9,0.4-1.4c0.7-1.8,1.9-3.4,3.1-4.8c0.6-0.8,1.3-1.5,2-2.2 c0.7-0.7,1.3-1.4,2.1-2c1.6-1.3,3.2-2.5,4.9-3.6c3.4-2.3,6.9-4.2,10.6-5.9c3.8-1.8,7.6-3.4,11.5-5c1.9-0.8,3.7-1.7,5.5-2.7 c0.9-0.5,1.8-1,2.6-1.5c0.8-0.5,1.6-1.2,2.4-1.9C60.8,22.8,61.5,22.1,62.3,21.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.8037,
    y1: -1.5203,
    x2: 24.6094,
    y2: 5.7125,
    gradientTransform: "matrix(0.9742 -1.968579e-02 2.141351e-02 0.9997 37.0235 19.379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003DA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6113,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.8,6.8c0.3-0.1,0.6,0,0.8,0.1C46,7,46.4,7.1,46.8,7.1c0.8,0.2,1.6,0.4,2.4,0.7c1.5,0.5,3,1.2,4.4,2 c2.5,1.4,4.6,3.4,6.3,5.8c0.5,0.7,1,1.5,1.3,2.4c0.1,0.3,0.4,0.6,0.4,1c0,0.3-0.2,0.8-0.5,0.9c-1.4-2.3-3-4.7-5.3-6.2 c-1.3-0.8-2.6-1.5-4.1-1.9c-0.7-0.2-1.5-0.4-2.3-0.5c-0.4,0-0.8-0.1-1.1-0.1c-0.3,0-0.8,0.1-1.1-0.1c-0.2-0.1-0.3-0.4-0.4-0.7 c-0.2-0.4-0.5-0.8-0.7-1.2c-0.2-0.4-0.4-0.8-0.7-1.2C45.2,7.6,44.9,7.2,44.8,6.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.9105,
    y1: 0.2925,
    x2: 25.5665,
    y2: 7.7856,
    gradientTransform: "matrix(0.9742 -1.968579e-02 2.141351e-02 0.9997 37.0235 19.379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007DA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1F1F2"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.3,21c-1.4-1.8-2.8-3.6-4.7-4.7c-1-0.6-2.1-1-3.2-1.1c-0.6-0.1-1.2,0-1.8,0c-0.2,0-0.6,0.2-0.8,0.1 c-0.2,0-0.3-0.2-0.3-0.4c-0.3-0.6-0.6-1.1-0.9-1.7c-0.1-0.2-0.3-0.5-0.4-0.7c-0.1-0.1-0.2-0.3-0.3-0.5 c-0.1-0.1-0.1-0.2,0.1-0.2c0.2,0,0.5,0,0.7,0c0.6,0,1.2,0.1,1.8,0.2c1.2,0.2,2.3,0.6,3.4,1.2c1,0.5,2.1,1.1,3,1.9 c1,0.8,1.8,1.8,2.5,2.9c0.4,0.6,0.7,1.2,1.1,1.7c0.1,0.2,0.4,0.5,0.4,0.7C60.6,20.7,60.4,20.8,60.3,21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.9266,
    y1: 0.4618,
    x2: 22.9161,
    y2: 4.0668,
    gradientTransform: "matrix(0.9742 -1.968579e-02 2.141351e-02 0.9997 37.0235 19.379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#0098CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6587,
    style: {
      stopColor: "#F1F1F2"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M50,16.1c1.7-0.2,3.5-0.1,5,0.7c1.5,0.8,2.7,2.1,3.8,3.4c0.3,0.3,0.5,0.6,0.8,0.9c0.2,0.2,0.4,0.5,0.2,0.8 c-0.1,0.1-0.1,0.2-0.2,0.1c-0.1-0.1-0.2-0.3-0.3-0.4c-0.3-0.4-0.6-0.7-0.9-1c-1.1-1.2-2.5-2.1-4.1-2.5c-0.5-0.1-1-0.2-1.5-0.1 c-0.2,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.2-0.1-0.3-0.3c-0.1-0.2-0.2-0.4-0.3-0.6 C50.6,17.1,50.3,16.6,50,16.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.5655,
    y1: 2.3901,
    x2: 24.4848,
    y2: 5.8765,
    gradientTransform: "matrix(0.9742 -1.968579e-02 2.141351e-02 0.9997 37.0235 19.379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07140828,
    style: {
      stopColor: "#95D600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#A2DB1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3111,
    style: {
      stopColor: "#D4EE96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4423,
    style: {
      stopColor: "#F3FAE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5026,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M58.9,22.5c-1.1-0.9-2.3-2-3.7-2.2c-0.7-0.1-1.5,0-2.2,0.3c-0.1,0.1-0.3,0.2-0.4,0.2 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.4-0.4-0.8-0.7-1.2c1.3-0.8,3-0.3,4.3,0.5c0.7,0.4,1.4,1,2,1.6c0.2,0.2,0.4,0.4,0.6,0.6 C58.7,22,59,22.3,58.9,22.5z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M63.4,22.3C63.4,22.3,63.5,22.3,63.4,22.3C63.5,22.3,63.4,22.3,63.4,22.3L63.4,22.3z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.9,54.9c-0.1-0.5-0.2-0.8-0.5-1.2c-1.3-2.3-2.7-4.5-4-6.8c-0.2-0.3-0.2-0.5-0.2-0.8 c0.2-1.2,0.6-2.3,1.2-3.4c0.2-0.4,0.4-0.7,0.7-1.1c0.7-1,1.5-2,2.3-3c0.1-0.1,0.1-0.1,0.2,0c0.4,0.7,0.8,1.4,1.2,2.1 c3.5,5.8,7,11.6,10.5,17.5c0.1,0.1,0.2,0.2,0.2,0.4c0,0,0,0,0,0c0,0,0,0,0,0c-23.6,0-47.3,0-71,0c-0.1-0.1,0-0.2,0.1-0.3 c1-1.7,2-3.3,3-5c6.3-10.5,12.6-21.1,18.9-31.6C29.3,15.4,33,9.1,36.8,2.9c0.2-0.4,0.1-0.4,0.7-0.4c1.1,0,2.1,0,3.2,0 c0.2,0,0.4,0.1,0.5,0.3c1.4,2.4,2.8,4.7,4.2,7.1c3.1,5.1,6.1,10.3,9.2,15.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0,0.1-0.1,0.2 c-0.7,0.3-1.3,0.6-2,0.9c-1.5,0.7-3.1,1.4-4.7,2c-0.2,0.1-0.2,0.1-0.3-0.1c-0.5-0.9-1-1.7-1.5-2.6c-3.1-5.3-6.2-10.7-9.4-16 c0,0,0,0,0-0.1c-0.1-0.1-0.1-0.3-0.3-0.3c-0.2,0-0.4,0-0.6,0.2c-0.1,0.1-0.1,0.1-0.1,0.2C28.4,22.5,21,34.9,13.5,47.4 c-0.5,0.9-1,1.8-1.4,2.8c-0.2,0.6-0.4,1.3-0.3,2c0.1,0.9,0.5,1.6,1.4,2c0.4,0.2,0.9,0.4,1.4,0.4c0.8,0.1,1.6,0.2,2.5,0.2 c9.2,0,18.3,0,27.5,0c6,0,12,0,18,0C62.7,54.9,62.8,54.9,62.9,54.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoraLogo);
export default __webpack_public_path__ + "static/media/cora-logo.d13f2a326be4693a7d12543b5e403d1c.svg";
export { ForwardRef as ReactComponent };